import { render, staticRenderFns } from "./c-quilleditor.vue?vue&type=template&id=560d3ca9&scoped=true"
import script from "./c-quilleditor.vue?vue&type=script&lang=js"
export * from "./c-quilleditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d3ca9",
  null
  
)

export default component.exports